module.exports = __webpack_public_path__ + "img/persons_yellow.937abe7a.svg";